import { render, staticRenderFns } from "./bankCreate.vue?vue&type=template&id=d53514b6&scoped=true&lang=html"
import script from "./bankCreate.vue?vue&type=script&lang=js"
export * from "./bankCreate.vue?vue&type=script&lang=js"
import style0 from "./bankCreate.vue?vue&type=style&index=0&id=d53514b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53514b6",
  null
  
)

export default component.exports